import React from 'react'
import { Theme } from '@mui/material'
import { StatItem } from '../StatItem/StatItem'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import { ICharacter } from '../../../../../../../../api/types/character'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      padding: theme.spacing(1),
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
    },
  })
)

interface Props {
  char: ICharacter
}

export const CalculatedStats: React.FC<Props> = ({ char }) => {
  const classes = useStyles()
  return (
    <div className={classes.card}>
      <StatItem name="Udźwig" value={Number(char.lifting_capacity).toFixed(0)} />
      <StatItem name="Prędkość" value={Number(char.speed).toFixed(1)} />
      <StatItem name="Inicjatywa" value={Number(char.initiative).toFixed(0)} />
      <StatItem name="Koncentracja" value={Number(char.concentration).toFixed(0)} />
      <StatItem name="Unik" value={Number(char.dodge).toFixed(0)} />
      <StatItem name="Blok" value={Number(char.block).toFixed(0)} />
      <StatItem name="Obrona" value={Number(char.defence).toFixed(0)} />
    </div>
  )
}
